import { backendGet } from "../../../services/dataService.js";

/**
 * Hook für CSV-Export
 */
export function useExportData({
  route,
  label,
  params,
  setIsLoading = () => {},
  enqueueSnackbar,
}) {
  const handleOnExportData = async () => {
    try {
      await backendGet(route, {
        label,
        setIsLoading,
        options: { params: params, responseType: "blob" },
        setResult: (resData) => {
          const blob = new Blob([resData], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
          const url = URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;

          const filename = label.toLowerCase().replace(/ /g, "_");

          a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.xlsx`;
          document.body.appendChild(a);
          a.click();

          URL.revokeObjectURL(url);
          document.body.removeChild(a);
        },
        enqueueSnackbar,
      });
    } catch (err) {
      console.error(`❌ Fehler beim Export (${label}):`, err);
      if (enqueueSnackbar) {
        enqueueSnackbar(`${label} Export fehlgeschlagen`, { variant: "error" });
      }
    }
  };

  return handleOnExportData;
}
